import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FrattaleService } from 'src/app/services/frattale.service';
import { MdbSortChange, MdbPaginationChange, MdbTableModule } from 'mdb-angular-ui-kit/table';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-storico',
  standalone: true,
  templateUrl: './storico.component.html',
  styleUrls: ['./storico.component.scss'],
  imports: [ReactiveFormsModule, MdbFormsModule, MdbSelectModule,
    MdbTableModule, CommonModule
  ]
})
export class StoricoComponent implements OnInit {
  storico: any = []
  markets: any = []
  days: any = [
    { value: 2, label: 'Lunedì' },
    { value: 3, label: 'Martedì' },
    { value: 4, label: 'Mercoledì' },
    { value: 5, label: 'Giovedì' },
    { value: 6, label: 'Venerdì' },
  ]
  oraOpen: any = []
  headers: any = [
    'Dayweek',
    'Open',
    'Close',
    'Punti',
    'Num. Op.',
    'Punti Op.',
    'Perc. Pos',
    'Rawal',
    'Kelly',
    'Sel.'
  ]
  tableData: any = []
  formFiltri: FormGroup = new FormGroup({
    selMarket: new FormControl(null),
    selDayweek: new FormControl('0'),
    selRawal: new FormControl(null),
    selOpen: new FormControl(0),
    selezionato: new FormControl(null)
  })

  constructor(private service: FrattaleService) {
    for (let i: number = 2; i < 24; i++) {
      this.oraOpen.push(i)
    }
  }

  ngOnInit(): void {
    this.service.getMarketsSymbols().subscribe((data: any) => {
      this.markets = data.data
    })
    this.fractimeStorico()
  }

  fractimeStorico() {
    this.service.fractimeStorico().subscribe((data: any) => {
      console.log(data)
      let d = data.data.map((el: any) => {
        el.rawal = el.punti > 0 ? el.rawal : 1 / el.rawal
        el.percpos = el.punti > 0 ? el.percpos : 1 - el.percpos
        //el.kelly = el.percpos - (1-el.percpos)/el.rawal
        return el
      })
      this.storico = d
    })
  }

  aggiornaStorico() {
    this.aggiornaMarket(0)
  }

  aggiornaMarket(id: number) {
    let mkt = this.markets[id].market
    console.log('aggiorna storico fractime per ', mkt)
    this.service.aggiornaStoricoFractime(mkt).subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        id++
        if (id < this.markets.length) {
          this.aggiornaMarket(id)
        }else{
          this.fractimeStorico()
        }
      }
    })
  }

  giornoSettimanaLabel(value: number): string {
    const day = this.days.find((d: any) => d.value == value);
    return day ? day.label : '';
  }

  selectMarket() {
    let mkt = this.formFiltri.get('selMarket')?.value.toLowerCase()
    this.tableData = this.storico.filter((el: any) => el.market == mkt)
    let gg = this.formFiltri.get('selDayweek')?.value
    if (gg > 0) {
      this.tableData = this.tableData.filter((el: any) => el.dayweek == gg)
    }
    let open = this.formFiltri.get('selOpen')?.value
    if (open > 0) {
      this.tableData = this.tableData.filter((el: any) => el.oraopen == open)
    }
  }

  onSortChange(event: MdbSortChange): void {
    console.log('sort change event', event);
    if (event.direction === 'none') {
      this.selectMarket()
      return
    } else {
      event.name = event.name.replace('.', '').toLowerCase()
      this.tableData = this.tableData.sort((a: any, b: any) => {
        let a1: number = a[event.name]
        let b1: number = b[event.name]
        if (event.direction === 'asc') {
          let c: number = a1 - b1 < 0 ? 1 : a1 - b1 > 0 ? -1 : 0
          return c
        }
        if (event.direction === 'desc') {
          let c: number = a1 - b1 < 0 ? -1 : a1 - b1 > 0 ? 1 : 0
          return c
        }
        return 0;
      });
    }

  }

  selezionaTS(id: number, ts: any) {
    this.service.fractimePref(id, ts.checked).subscribe((data: any) => {
      console.log(data)
    })
  }

}
